"use strict";

import {NgModule} from "@angular/core";
import {LLMRecInfoWindowComponent} from "./llm_rec_info_window";
import {BrowserModule} from "@angular/platform-browser";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {ModalDialogModule} from "../../components/modal-dialog/modal-dialog.module";
import {CommonModule} from "@angular/common";
import {DropdownModule} from "../../components/dropdown-new/dropdown.module";
import {PipesModule} from "../../common/pipes/pipes.module";
import {RatingModule} from "../../components/rating/rating.module";
import {RatingOrPredictionModule} from "../../components/rating-or-prediction/rating-or-prediction.module";
import {YoutubeModule} from "../../components/youtube/youtube.module";
import {UIRouterModule} from "@uirouter/angular";
import {ExternalRecsModule} from "../externalrecs/external-recs.module";
import {AngularMyDatePickerModule} from "angular-mydatepicker";
import { LLMRecService } from "./llm_rec.service";

export const introPage = {
    states: [
        {
            name: "restricted.PageLLMRecInfoWindow",
            url: "/llm-rec-info-window",
            component: LLMRecInfoWindowComponent
        }
    ]
};

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        ModalDialogModule,
        CommonModule,
        DropdownModule,
        ModalDialogModule,
        PipesModule,
        RatingModule,
        RatingOrPredictionModule,
        YoutubeModule,
        UIRouterModule.forChild(introPage),
        ExternalRecsModule,
        ReactiveFormsModule,
        AngularMyDatePickerModule
    ],
    exports: [],
    declarations: [
        LLMRecInfoWindowComponent
    ],
    entryComponents: [
        LLMRecInfoWindowComponent
    ],
    providers : [LLMRecService]
})

export class LLMRecExptModule {
}